import { OrderItemState } from 'src/types/redux';
import {
  FETCH_ORDER_ITEMS_FAILURE,
  FETCH_ORDER_ITEMS_REQUEST,
  FETCH_ORDER_ITEMS_SUCCESS,
  OrderItemsActionType,
  SET_ORDER_CACHE,
  SET_ORDER_DATE,
  SET_ORDER_FILTERS,
  SET_ORDER_PAYMENT_TYPE,
  TRIGGER_ORDERS_REFETCH,
} from '../types/orderItemsType';
import { endOfToday, oneWeekAgoDate } from 'src/utils/dateOneMonthAgo';
import {
  payment_status,
} from '../../components/payment-status';

const initialState: OrderItemState = {
  error: '',
  loading: false,
  orderStartDate: new Date(oneWeekAgoDate().setHours(0,0,0,0)),
  orderEndDate: new Date(endOfToday().setHours(0,0,0,0)),
  orderPaymentType: payment_status[0],
  filters: {
    page: 1,
    limit: 10,
    totalPages: 1,
  },
  ordersCache: {
    query: '',
    data: []
  },
  orderItemsData: {
    items: [],
    combos: [],
    discounts: [],
    customItems: [],
    categoriesWithItems: [],
  },
  refetch: false
};

export const orderItemReducer = (
  state = initialState,
  action: OrderItemsActionType
): OrderItemState => {
  switch (action?.type) {
    case FETCH_ORDER_ITEMS_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case FETCH_ORDER_ITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        orderItemsData: action?.payload,
      };
    case FETCH_ORDER_ITEMS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action?.payload,
      };
    case SET_ORDER_DATE:
      return {
        ...state,
        orderStartDate: action?.payload?.orderStartDate,
        orderEndDate: action?.payload?.orderEndDate,
      };
    case SET_ORDER_CACHE:
      return {
        ...state,
        ordersCache: {
          query: action.payload.query,
          data: action.payload.data,
        }
      };
    case SET_ORDER_FILTERS:
      return {
        ...state,
        filters: action.payload
      };
    case SET_ORDER_PAYMENT_TYPE:
      return {
        ...state,
        orderPaymentType: action.payload
      };
    case TRIGGER_ORDERS_REFETCH :
      return {
      ...state,
      refetch: action.payload
    };
    default:
      return state;
  }
};
